enum ErrorCode {
	INVALID_PASSWORD = 'INVALID_PASSWORD',
	EMAIL_ALREADY_EXISTS = 'EMAIL_ALREADY_EXISTS',
	INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
	SAME_OLD_NEW_PASSWORD = 'SAME_OLD_NEW_PASSWORD',
	USER_NOT_FOUND = 'USER_NOT_FOUND',
	INVALID_FORMAT_EMAIL = 'INVALID_FORMAT_EMAIL',
	INVALID_FORMAT_PASSWORD = 'INVALID_FORMAT_PASSWORD',
	INVALID_OR_EXPIRED_TOKEN_REGISTRATION = 'INVALID_OR_EXPIRED_TOKEN_REGISTRATION',
}

export default ErrorCode;